import React, { useEffect, useState } from "react";
import Card from "../../components/common/Card";
import "./MyProfile.css";
import { useFormik } from "formik";

const Profile = () => {
  const [activeTab, setActiveTab] = useState("personal");
  const [formData, setFormData] = useState({
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    phone: "+1234567890",
    designation: "Senior Mining Engineer",
    department: "Engineering",
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [user, setUser] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (localStorage.getItem("user") != null) {
      setUser(JSON.parse(localStorage.getItem("user")));
      formik.setValues({
        fullName: JSON.parse(localStorage.getItem("user"))?.fullName,
        email: JSON.parse(localStorage.getItem("user"))?.email,
        phoneNumber: JSON.parse(localStorage.getItem("user"))?.mobile,
      });
    }
  }, []);

  const handlePersonalInfoSubmit = (e) => {
    e.preventDefault();
    // Handle personal info update
    // console.log("Personal Info Update:", formData);
  };

  const handlePasswordChange = (e) => {
    e.preventDefault();
    // Handle password change
  };

  const formik = useFormik({
    initialValues: {
      fullName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      designation: "",
      department: "",
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    onSubmit: async (values) => {},
  });
  return (
    <div className="profile-container" id="myprofile">
      <Card title="My Profile">
        <div className="profile-header">
          <div className="profile-avatar">
            <div className="avatar-circle">
              {/* <span>{user?.fullName}</span> */}
            </div>
            <div className="profile-info">
              <h2>{user?.fullName}</h2>
              {/* <p>{formData.designation}</p> */}
            </div>
          </div>
        </div>

        <div className="profile-tabs">
          <button
            className={`tab-button ${activeTab === "personal" ? "active" : ""}`}
            onClick={() => setActiveTab("personal")}
          >
            <i className="fas fa-user"></i> Personal Information
          </button>
          {/* <button
            className={`tab-button ${activeTab === "password" ? "active" : ""}`}
            onClick={() => setActiveTab("password")}
          >
            <i className="fas fa-lock"></i> Change Password
          </button> */}
        </div>

        <div className="tab-content">
          {activeTab === "personal" ? (
            <form onSubmit={formik.handleSubmit} className="profile-form">
              <div className="form-row">
                <div className="form-group">
                  <label>First Name</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formik.values.fullName}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                  />
                </div>
                {/* <div className="form-group">
                  <label>Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    value={formik.values.}
                    onChange={handleInputChange}
                  />
                </div> */}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    value={formik.values.phoneNumber}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Designation</label>
                  <input
                    type="text"
                    name="designation"
                    value={formik.values.designation}
                    onChange={formik.handleChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Department</label>
                  <input
                    type="text"
                    name="department"
                    value={formData.department}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {/* <div className="form-actions">
                <button type="submit" className="btn btn-primary">
                  <i className="fas fa-save"></i> Save
                </button>
              </div> */}
            </form>
          ) : (
            <form onSubmit={handlePasswordChange} className="profile-form">
              <div className="form-group">
                <label>Current Password</label>
                <div className="password-input">
                  <input
                    type="password"
                    name="currentPassword"
                    value={formData.currentPassword}
                    onChange={handleInputChange}
                  />
                  <i className="fas fa-eye"></i>
                </div>
              </div>

              <div className="form-group">
                <label>New Password</label>
                <div className="password-input">
                  <input
                    type="password"
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleInputChange}
                  />
                  <i className="fas fa-eye"></i>
                </div>
              </div>

              <div className="form-group">
                <label>Confirm New Password</label>
                <div className="password-input">
                  <input
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                  />
                  <i className="fas fa-eye"></i>
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="btn btn-primary">
                  <i className="fas fa-key"></i> Update Password
                </button>
              </div>
            </form>
          )}
        </div>
      </Card>
    </div>
  );
};

export default Profile;
